import { Typography } from 'core/Typography';
import Image from 'next/image';
import React from 'react';
import SectionWrapper from 'shared/SectionWrapper';

function CardIcon({ title, image }: { title?: string; image?: string }) {
    return (
        // eslint-disable-next-line max-len
        <div className="p-[24px] xl-desktop:p-[40px] gap-[24px] flex  flex-col bg-bg-grey rounded-[24px] ">
            {image && (
                <div className={'size-[48px] min-w-[48px] min-h-[48px] relative'}>
                    <Image fill src={`${image}`} alt={title || ''} objectFit={'contain'} />
                </div>
            )}

            <Typography>{title}</Typography>
        </div>
    );
}

function CardText({ title, desc }: { title?: string; desc?: string }) {
    return (
        // eslint-disable-next-line max-len
        <div className="p-[24px] xl-desktop:p-[40px] gap-[8px] flex flex-col bg-bg-grey rounded-[24px] ">
            <Typography
                color="accent-cold"
                className="font-semibold! mobile:text-[64px] text-[34px] leading-[140%]! mobile:leading-[150%]!"
            >
                {desc}
            </Typography>

            <Typography className="font-semibold!">{title}</Typography>
        </div>
    );
}

function Results() {
    return (
        <SectionWrapper>
            <div className="flex flex-col gap-[40px] lg-tablet:gap-[60px]">
                <div className="flex flex-col gap-[12px] mobile:gap-[16px] lg-tablet:gap-[24px]">
                    <Typography variant="h2">Результаты и ценность</Typography>
                    <Typography className="lg-tablet:max-w-8/12">
                        Первую пилотную версию мы протестировали внутри своего агентства. Полученные
                        результаты подтвердили точность анализа и пользу продукта для ускорения
                        найма.
                    </Typography>
                </div>

                <div
                    className={
                        // eslint-disable-next-line max-len
                        'grid grid-cols-1 lg-tablet:grid-cols-3 gap-[24px] xl-desktop:gap-y-[24px] xl-desktop:gap-x-[40px]'
                    }
                >
                    <CardText title={'сокращение времени анализа интервью'} desc={'х9'} />
                    <CardText desc={'87%'} title={'совпадение с экспертной оценкой'} />
                    <CardText desc={'на 80%'} title={'ускорение принятия решений'} />
                </div>

                <div className="flex flex-col gap-[24px]">
                    <Typography variant={'h3'}>Ключевые преимущества:</Typography>

                    <div className="flex flex-col gap-[24px]">
                        <div
                            className={
                                // eslint-disable-next-line max-len
                                'grid grid-cols-1 lg-tablet:grid-cols-2 gap-[24px] xl-desktop:gap-y-[24px] xl-desktop:gap-x-[40px]'
                            }
                        >
                            <CardIcon
                                image={'/images/pic/talent-mind/results-icon-1.svg'}
                                title={
                                    'Ускорение найма — сокращение времени на оценку кандидата до 80%'
                                }
                            />
                            <CardIcon
                                image={'/images/pic/talent-mind/results-icon-2.svg'}
                                title={
                                    'Точность выше классических оценок, обучение на реальных интервью'
                                }
                            />
                            <CardIcon
                                image={'/images/pic/talent-mind/results-icon-3.svg'}
                                title={'Снижение ошибок найма и уменьшение оттока сотрудников'}
                            />
                            <CardIcon
                                image={'/images/pic/talent-mind/results-icon-4.svg'}
                                title={
                                    'Развёртывание внутри периметра клиента (персональные данные не покидают компанию)'
                                }
                            />
                        </div>
                        <div
                            className={
                                // eslint-disable-next-line max-len
                                'grid grid-cols-1 lg-tablet:grid-cols-3 gap-[24px] xl-desktop:gap-y-[24px] xl-desktop:gap-x-[40px]'
                            }
                        >
                            <CardIcon
                                title={'Анализ эмоций кандидата на основе видео (скоро появится)'}
                                image={'/images/pic/talent-mind/results-icon-5.svg'}
                            />
                            <CardIcon
                                image={'/images/pic/talent-mind/results-icon-6.svg'}
                                title={
                                    'Дозагрузка данных после нескольких итераций интервью (скоро появится)'
                                }
                            />
                            <CardIcon
                                image={'/images/pic/talent-mind/results-icon-7.svg'}
                                title={'Сравнение кандидатов (скоро появится)'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </SectionWrapper>
    );
}

export default Results;
